<template>
  <div class="indexFooter">
    <div class="auto">
      <div class="guild">
        <dl>
          <dt>支付方式</dt>
          <dd>银行汇款帐户</dd>
          <dd>
            <router-link :to="'/remittanceAccount'" target="_blank">查看账户></router-link>
          </dd>
        </dl>
        <dl>
          <dt></dt>
          <dd>第三方支付</dd>
          <dd>
            <img src="../../assets/images/icon/zfb.png" alt="">
            <img src="../../assets/images/icon/wx2.png" alt="" class="wx">
          </dd>
        </dl>
        <dl>
          <dt>咨询热线</dt>
          <dd>
            <span class="tel">021-20219999</span>
            <!-- <span class="tel">021-20219999</span> -->
          </dd>
        </dl>

      </div>
      <div class="code">
        <img src="../../assets/images/home/code2.png" alt="">
        <p>扫码获取一对一服务</p>
      </div>
    </div>
    <app-footer/>
  </div>
</template>

<script>
import AppFooter from "@/components/common/AppFooter.vue";
export default {
  props: {
    msg: String
  },
  data() {
    return {
       codeUrl: require("@/assets/images/common/code.jpg"),
    };
  },
  components: {
    AppFooter
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/HomeFooter.vue